import { render, staticRenderFns } from "./DisplayConsigneeUploadInfo.vue?vue&type=template&id=d35ecf90&"
import script from "./DisplayConsigneeUploadInfo.vue?vue&type=script&lang=ts&"
export * from "./DisplayConsigneeUploadInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports